var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "check_circle"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1894_83187",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1894_83187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_circle_2",
    d: "M44.1663 69.1668L73.5413 39.7918L67.708 33.9585L44.1663 57.5002L32.2913 45.6252L26.458 51.4585L44.1663 69.1668ZM49.9997 91.6668C44.2358 91.6668 38.8191 90.5731 33.7497 88.3856C28.6802 86.1981 24.2705 83.2293 20.5205 79.4793C16.7705 75.7293 13.8018 71.3196 11.6143 66.2502C9.42676 61.1807 8.33301 55.764 8.33301 50.0002C8.33301 44.2363 9.42676 38.8196 11.6143 33.7502C13.8018 28.6807 16.7705 24.271 20.5205 20.521C24.2705 16.771 28.6802 13.8022 33.7497 11.6147C38.8191 9.42725 44.2358 8.3335 49.9997 8.3335C55.7636 8.3335 61.1802 9.42725 66.2497 11.6147C71.3191 13.8022 75.7288 16.771 79.4788 20.521C83.2288 24.271 86.1976 28.6807 88.3851 33.7502C90.5726 38.8196 91.6663 44.2363 91.6663 50.0002C91.6663 55.764 90.5726 61.1807 88.3851 66.2502C86.1976 71.3196 83.2288 75.7293 79.4788 79.4793C75.7288 83.2293 71.3191 86.1981 66.2497 88.3856C61.1802 90.5731 55.7636 91.6668 49.9997 91.6668ZM49.9997 83.3335C59.3052 83.3335 67.1872 80.1043 73.6455 73.646C80.1038 67.1877 83.333 59.3057 83.333 50.0002C83.333 40.6946 80.1038 32.8127 73.6455 26.3543C67.1872 19.896 59.3052 16.6668 49.9997 16.6668C40.6941 16.6668 32.8122 19.896 26.3538 26.3543C19.8955 32.8127 16.6663 40.6946 16.6663 50.0002C16.6663 59.3057 19.8955 67.1877 26.3538 73.646C32.8122 80.1043 40.6941 83.3335 49.9997 83.3335Z",
    fill: "#36B37E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.bb30fc11b630a12b226715d380cb1555.svg";
export { ForwardRef as ReactComponent };